import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, User, ArrowRight, ArrowLeft } from 'lucide-react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import Footer from './Footer';
import './BlogList.css';
import './PublicLanding.css';

function BlogList() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get('/api/blog/', {
          params: { is_published: true }
        });
        console.log('BlogList: получены посты:', response.data);
        setPosts(response.data || []);
      } catch (error) {
        console.error('Error fetching blog posts:', error);
        setPosts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="blog-list-loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  const content = (
    <>
      {/* Публичный хедер для неавторизованных */}
      {!user && (
        <header className="public-header">
          <div className="public-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
            <img src="/logo.png" alt="Pikly" />
            <span>PIKLY</span>
          </div>
          <div className="public-actions">
            <button className="btn ghost" onClick={() => navigate('/register')}>Регистрация</button>
            <button className="btn primary" onClick={() => navigate('/login')}>Вход</button>
          </div>
        </header>
      )}
      
      <div className="blog-list-page">
        <div className="blog-list-container">
          {!user && (
            <button 
              className="blog-list-back"
              onClick={() => navigate('/')}
            >
              <ArrowLeft size={20} />
              На главную
            </button>
          )}
          <h1 className="blog-list-title">Блог</h1>
          <p className="blog-list-subtitle">Последние новости и статьи о технологиях AI</p>

        {posts.length === 0 ? (
          <div className="blog-list-empty">
            <p>Статьи пока не опубликованы</p>
          </div>
        ) : (
          <div className="blog-list-grid">
            {posts.map((post) => (
              <article 
                key={post.id} 
                className="blog-post-card"
                onClick={() => navigate(`/blog/${post.slug}`)}
              >
                {post.image_url && (
                  <div className="blog-post-image">
                    <img 
                      src={post.image_url} 
                      alt={post.title}
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                )}
                <div className="blog-post-content">
                  <h2 className="blog-post-title">{post.title}</h2>
                  {post.subtitle && (
                    <p className="blog-post-subtitle">{post.subtitle}</p>
                  )}
                  {post.excerpt && (
                    <p className="blog-post-excerpt">{post.excerpt}</p>
                  )}
                  <div className="blog-post-meta">
                    {post.author && (
                      <div className="blog-post-author">
                        <User size={16} />
                        <span>{post.author}</span>
                      </div>
                    )}
                    {post.published_at && (
                      <div className="blog-post-date">
                        <Calendar size={16} />
                        <span>{formatDate(post.published_at)}</span>
                      </div>
                    )}
                  </div>
                  <button className="blog-post-read-more">
                    Читать далее
                    <ArrowRight size={16} />
                  </button>
                </div>
              </article>
            ))}
          </div>
        )}
        </div>
      </div>
      
      {/* Публичный футер для неавторизованных */}
      {!user && <Footer />}
    </>
  );

  // Если пользователь авторизован, возвращаем без обертки public-landing (используется внутри Dashboard)
  if (user) {
    return content;
  }

  // Если не авторизован, оборачиваем в public-landing для публичного вида
  return <div className="public-landing">{content}</div>;
}

export default BlogList;
